import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Plan, PlanCreate, PlanUpdate } from '../../shared/models/plans.models';

@Injectable({
  providedIn: 'root',
})
export class PlansService {
  private http = inject(HttpClient);

  public getAll(): Observable<Plan[]> {
    return this.http.get<Plan[]>('/system-user/plans');
  }

  public getOneById(id: number): Observable<Plan> {
    return this.http.get<Plan>(`/system-user/plans/${id}`);
  }

  public create(data: PlanCreate): Observable<Plan> {
    return this.http.post<Plan>('/system-user/plans', data);
  }

  public update(data: PlanUpdate): Observable<Plan> {
    return this.http.patch<Plan>(`/system-user/plans/${data.id}`, {
      name: data.name,
      quota: data.quota,
    });
  }

  public delete(id: number): Observable<void> {
    return this.http.delete<void>(`/system-user/plans/${id}`);
  }
}
